import { __rest } from "tslib";
import { InputNumber as $InputNumber } from 'antd';
import * as React from 'react';
import Field from '../field';

const useCreateRefCB = () => {
    const ref = React.useRef();
    const cb = React.useCallback((props) => ref.current(props), []);
    return (func) => { (ref.current = func); return cb; };
};
const MemoInputNumber = React.memo($InputNumber);

export const InputNumber = (_a) => {
    var { name, validate, fast, onChange: $onChange, onBlur: $onBlur } = _a, restProps = __rest(_a, ["name", "validate", "fast", "onChange", "onBlur"]);
    const memoBlur = useCreateRefCB();
    const memoChange = useCreateRefCB();
    return (React.createElement(Field, { name: name, validate: validate, fast: fast }, ({ field: { value, onBlur }, form: { setFieldValue } }) => (React.createElement(MemoInputNumber, Object.assign({ name: name, value: value, onChange: memoChange((value) => {
            setFieldValue(name, value);
            $onChange && $onChange(value);
        }), onBlur: memoBlur((event) => {
            onBlur(event);
            $onBlur && $onBlur(event);
        }) }, restProps)))));
};
export default InputNumber;
//# sourceMappingURL=index.js.map